<template>
    <h6 class="block px-1.5 py-1 text-xs text-gray-400 uppercase tracking-widest font-medium">
        <slot></slot>
    </h6>
</template>

<script>
export default {
    //
}
</script>
